"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallToActionButton = exports.CancelButton = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var storm_ui_1 = require("@amzn/storm-ui");
exports.CancelButton = (0, styled_components_1.default)(storm_ui_1.TextButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", ";\n"], ["\n  margin: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.mini;
});
exports.CallToActionButton = (0, styled_components_1.default)(storm_ui_1.TextButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  /*pointerEvents is needed for the disabled button to work with tooltip as mentioned in Storm's doc*/\n  pointer-events: none;\n"], ["\n  /*pointerEvents is needed for the disabled button to work with tooltip as mentioned in Storm's doc*/\n  pointer-events: none;\n"])));
var templateObject_1, templateObject_2;
